import { render, staticRenderFns } from "./FormOfferRequestSummary.vue?vue&type=template&id=84775168&"
import script from "./FormOfferRequestSummary.vue?vue&type=script&lang=js&"
export * from "./FormOfferRequestSummary.vue?vue&type=script&lang=js&"
import style0 from "./FormOfferRequestSummary.vue?vue&type=style&index=0&id=84775168&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports